import styled from 'styled-components';

export const EpaRaceChartWrap = styled.div`
  grid-area: epa;
  min-width: 0;

  /* Strip the header/body divider like the other summary cards */
  article > header {
    border-bottom: none;
  }

  article > div > div {
    padding-top: 0;
  }

  /* Fill the grid cell; prevent internal overflow from escaping. */
  article {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }
`;

export const Legend = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};
  align-items: center;
  padding: ${({ theme }) => theme.sizing.small} 0 0 0;
  color: ${({ theme }) => theme.colours.ink.primary.main};
`;

export const ChartCanvas = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.sizing.small} 0;

  /* Force the SVG to respect the configured chartWidth/chartHeight rather
     than CSS-stretching to its container. Without this, kitbag's default
     SVG width: 100% on a wide container scales the whole chart (including
     text) to fill available space. */
  svg {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Team line thickness — 1 keeps the lines fine so overlapping team series
     stay readable (the library default is 2). The scoring-play guide lines
     are 0.75, so the team lines are only slightly heavier than the guides.
     This selector also thins the axis domain path. */
  svg path[fill='none'][stroke]:not([stroke='none']) {
    stroke-width: 1;
  }

  /* Axis text (labels + tick labels) — $axisColor comes from visPalette.axis,
     the same token PassPlacement, Timeline, and every other IQ vis passes to
     D3's .attr() calls. getPalette(isDark) returns the correct value for the
     active theme — #999999 in both light and dark for axis labels.
     Font size 10px = VISUALISATION_FONT_SETUPS.AXES_VALUES_SMALL = BODY_SMALL.
     Sizes come from theme.typography.bodySmall. */
  svg text {
    fill: ${({ $axisColor }) => $axisColor};
    font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
    font-weight: ${({ theme }) => theme.typography.bodySmall.fontWeight};
    font-family: ${({ theme }) => theme.font.family};
  }

  /* Axis tick marks — target only ticks (inside D3's .tick groups) so we
     don't override the guide lines' library-supplied stroke colour. */
  svg g.tick line {
    stroke: ${({ $axisColor }) => $axisColor};
  }

  /* Axis domain (the main axis line itself) when d3-axis-for-react emits
     it with the .domain class. */
  svg .domain {
    stroke: ${({ $axisColor }) => $axisColor};
  }

  /* Axis labels render with text-anchor="start" by default in kitbag, which
     leaves them stuck to one end of the axis. Override so they centre on
     whatever position kitbag's chart layout put them at. Tick labels use
     "middle" (bottom axis) or "end" (left axis) so targeting text-anchor="start"
     picks out only the axis labels themselves. */
  svg text[text-anchor='start'] {
    text-anchor: middle;
  }
`;
